/**
 * Login screen shown when user is not authenticated.
 * Redirects to Cognito/Federate for Midway SSO.
 */
import React from 'react';
import { useAuth } from '../auth';

const LoginScreen: React.FC = () => {
  const { login, authError } = useAuth();

  return (
    <div className="login-screen">
      <div className="login-card">
        <h1>AETHER</h1>
        <p>Aircraft Event Tracking &amp; Handling for Enhanced Reliability</p>
        {authError && (
          <div className="login-error">
            <strong>Authentication Error:</strong> {authError}
          </div>
        )}
        <button className="login-btn" type="button" onClick={login}>
          Sign in with Midway
        </button>
        <div className="login-access-request">
          <p>For access to this tool please submit a SIM.</p>
          <a
            href="https://t.corp.amazon.com/create/templates/a53024be-b07e-4f5d-8281-1883d059ca67"
            target="_blank"
            rel="noopener noreferrer"
            className="login-sim-link"
          >
            Request Access
          </a>
        </div>
        <span className="login-credit">Developed by MXO-DEV</span>
      </div>
    </div>
  );
};

export default LoginScreen;
